import InfoMark from './info-mark';

export default InfoMark;